import { BusinessObjectBase } from './base';
import type { Candidate } from './candidate';

export interface AddressData {
  readonly id: number;
  readonly legalAddress?: string;
  readonly city?: string;
  readonly country?: string;
  readonly currentAddress?: string;
  readonly candidateId: number;
  readonly candidate?: Candidate;
}

export interface Address extends Readonly<AddressData> {}
export class Address extends BusinessObjectBase {
  static readonly entityName = 'Address' as const;
  static readonly plural = 'addresses';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<Address[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new Address(data));
  }

  static async findOne(filter?: any): Promise<Address | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new Address(data) : null;
  }

  static async findById(id: number, filter?: any): Promise<Address> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new Address(data);
  }

  static async create(data: Omit<AddressData, 'id'>): Promise<Address> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new Address(result);
  }

  static async updateById(
    id: number,
    data: Partial<AddressData>,
  ): Promise<Address> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new Address(result);
  }

  static async deleteById(id: number): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
